export default __webpack_public_path__ + "static/editor-4632e7ebac4cc92a93aab28ec89b3e5b.webm";